import { render, staticRenderFns } from "./ShortcutMenuPop.vue?vue&type=template&id=09f007e5&scoped=true"
import script from "./ShortcutMenuPop.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortcutMenuPop.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ShortcutMenuPop.vue?vue&type=style&index=0&id=09f007e5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f007e5",
  null
  
)

export default component.exports